/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_UnavailableInputs */



/**
* | output |
* | --- |
* | "Single sign-on is not set up for this workspace right now. Sign in another way, or ask your admin." |
*
* @param {Signin_Sso_X15_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_unavailable = /** @type {((inputs?: Signin_Sso_X15_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Single sign-on is not set up for this workspace right now. Sign in another way, or ask your admin.")
});